import Vue from 'vue';
import billPaymentTransformer from './../../transformers/billPayment';

const success = (resolve, response) => {
  if (response.data.data) {
    const result = {
      errors: response.data.errors,
      data: billPaymentTransformer.fetchCollection(response.data.data),
    };
    resolve(result);
  } else {
    resolve(billPaymentTransformer.fetch(response.data));
  }
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(billPaymentTransformer.fetch(errors));
};

export default (billId, params = {}) => (
  new Promise((resolve, reject) => {
    const data = billPaymentTransformer.send(params);
    Vue.$http
      .post(`/bills/payment/${billId}`, data)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/payment.js